/* SOLSTICE — wishlist.js : localStorage, badge compteur, page wishlist */
(function () {
  'use strict';
  const KEY = 'solstice:wishlist';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    updateBadges();
  }
  function toggle(handle) {
    const list = read();
    const i = list.indexOf(handle);
    if (i >= 0) list.splice(i, 1); else list.push(handle);
    write(list);
    return i < 0;
  }

  function updateBadges() {
    const list = read();
    document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
      el.textContent = list.length;
      el.classList.toggle('hidden', list.length === 0);
    });
    document.querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
      const active = list.includes(btn.dataset.wishlistToggle);
      btn.setAttribute('aria-pressed', String(active));
      const icon = btn.querySelector('.icon');
      if (icon) icon.style.fill = active ? 'currentColor' : 'none';
    });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    const added = toggle(btn.dataset.wishlistToggle);
    window.SolsticeUtils.toast(added ? window.Solstice.strings.added : '—');
  });

  updateBadges();
  document.addEventListener('collection:updated', updateBadges);
  document.addEventListener('shopify:section:load', updateBadges);

  /* ---------- Wishlist page rendering ---------- */
  const page = document.querySelector('[data-wishlist-page]');
  if (page) renderPage();

  async function renderPage() {
    const list = read();
    const empty = page.querySelector('[data-wishlist-empty]');
    const grid = page.querySelector('[data-wishlist-grid]');
    if (!list.length) { if (empty) empty.classList.remove('hidden'); return; }
    if (empty) empty.classList.add('hidden');
    const cards = await Promise.all(list.map(async (handle) => {
      try {
        const res = await fetch(`/products/${handle}?section_id=quick-view`);
        if (!res.ok) return '';
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const el = doc.querySelector('[data-qv-root]');
        if (!el) return '';
        const img = el.querySelector('.qv__img');
        const title = el.querySelector('.buybox__title')?.textContent || handle;
        const price = el.querySelector('.price__now')?.textContent || '';
        const variantId = el.querySelector('[data-variant-id]')?.value;
        return `
          <div class="card">
            <div class="card__media"><a href="/products/${handle}">${img ? img.outerHTML : ''}</a>
              <div class="card__actions" style="opacity:1;transform:none">
                <button class="card__action-btn" data-wishlist-toggle="${handle}" aria-pressed="true" aria-label="Remove">
                  <svg class="icon" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.6"><path d="M12 20.5C7 16.5 3.5 13.3 3.5 9.6 3.5 7 5.5 5 8 5c1.6 0 3.1.8 4 2.1C12.9 5.8 14.4 5 16 5c2.5 0 4.5 2 4.5 4.6 0 3.7-3.5 6.9-8.5 10.9Z"/></svg>
                </button>
              </div>
            </div>
            <div class="card__info">
              <p class="card__title"><a href="/products/${handle}">${title}</a></p>
              <div class="price"><span class="price__now">${price}</span></div>
              ${variantId ? `<button class="btn" style="margin-top:10px;width:100%;padding-block:.8em" data-quick-add="${variantId}">${window.Solstice.strings.addToCart}</button>` : ''}
            </div>
          </div>`;
      } catch (e) { return ''; }
    }));
    grid.innerHTML = cards.join('');

    /* Re-render after removal */
    grid.addEventListener('click', (e) => {
      if (e.target.closest('[data-wishlist-toggle]')) setTimeout(renderPage, 50);
    }, { once: true });
  }
})();
